import type { ProRenderFieldPropsType } from '@ant-design/pro-provider';
import React from 'react';
import UserLoginName from '@/components/UserLoginName';

/** ProTable / ProDescriptions 自定义 valueType 插件 */
export const proValueTypeMap: Record<string, ProRenderFieldPropsType> = {
  loginName: {
    render: (text) => <UserLoginName id={text == null ? undefined : String(text)} />,
  },
};
